import type { JSX } from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { CompanyUserActions } from './CompanyUserActions';
import { roleBadgeLabel, roleColors } from '../utils/company-user.utils';
import type { CompanyUser } from '../types/company-admin.types';

export interface CompanyUserRowProps {
  user: CompanyUser;
  currentUserId?: string | undefined;
  onEdit: (user: CompanyUser) => void;
}

export function CompanyUserRow({ user, currentUserId, onEdit }: CompanyUserRowProps): JSX.Element {
  return (
    <TableRow>
      <TableCell>
        <div>
          <p className="font-medium">{user.fullName}</p>
          <p className="text-sm text-muted-foreground">{user.email}</p>
        </div>
      </TableCell>
      <TableCell>
        <div className="flex flex-wrap gap-1">
          {user.roles.map((role) => (
            <Badge key={role} variant={roleColors[role] ?? 'outline'}>
              {roleBadgeLabel(role)}
            </Badge>
          ))}
        </div>
      </TableCell>
      <TableCell>
        <Badge variant={user.isActive ? 'default' : 'destructive'}>
          {user.isActive ? 'Active' : 'Inactive'}
        </Badge>
      </TableCell>
      <TableCell className="text-muted-foreground">
        {user.lastLoginAt ? new Date(user.lastLoginAt).toLocaleDateString() : 'Never'}
      </TableCell>
      <TableCell>
        <CompanyUserActions user={user} onEdit={onEdit} isCurrentUser={user.id === currentUserId} />
      </TableCell>
    </TableRow>
  );
}
